<template>
  <div>
    <PageBar Image="img/article_p_bn.jpg" :Breadcrumbs="Breadcrumbs"></PageBar>
    <div class="main">
      <div class="container" v-if="Exam && Lesson && User">
        <h1>
          {{ Lesson.Title }}
        </h1>
        <div class="pageBox">
          <div class="qustionPage">
            <div class="testerInfo">
              <p class="name">姓名: {{ User.name || User.Name }}</p>
              <p class="subject">{{ Exam.Title }}</p>
              <p class="testID">准考證號碼: {{ StartTime }}</p>
            </div>
            <div class="remainTime">
              剩餘時間:
              <span class="minute">{{ LeftMin }}</span> 分
              <span class="second">{{ LeftSec }}</span> 秒
            </div>

            <template v-if="Questions">
              <ol class="questionList" v-if="Questions.Single.length > 0">
                <li
                  class="questionList-item"
                  v-for="(q, i) in Questions.Single"
                  :key="q.Title"
                >
                  <h3>
                    {{ q.Title }}
                  </h3>
                  <div class="answers">
                    <label
                      :for="'a' + i + '-' + idx"
                      v-for="(c, idx) in q.Choices"
                      :key="c.Title"
                    >
                      <input
                        type="radio"
                        :id="'a' + i + '-' + idx"
                        :name="'a' + i"
                        :value="idx"
                        v-model="q.Answer"
                      />
                      （{{ idx + 1 }}） {{ c.Title }}
                    </label>
                  </div>
                </li>
              </ol>

              <hr v-if="Questions.Single.length > 0 && Questions.Multiple.length > 0"/>

              <ol class="questionList"  v-if="Questions.Multiple.length > 0">
                <li
                  class="questionList-item"
                  v-for="(q, i) in Questions.Multiple"
                  :key="q.Title"
                >
                  <h3>
                    {{ q.Title }}
                  </h3>
                  <div class="answers">
                    <label
                      :for="'b' + i + '-' + idx"
                      v-for="(c, idx) in q.Choices"
                      :key="c.Title"
                    >
                      <input
                        type="checkbox"
                        :id="'b' + i + '-' + idx"
                        :name="'b' + i"
                        :value="idx"
                        v-model="q.Answer"
                      />
                      （{{ idx + 1 }}） {{ c.Title }}
                    </label>
                  </div>
                </li>
              </ol>

              <hr v-if="Questions.Multiple.length > 0 && Questions.Question.length > 0"/>

              <ol class="questionList" v-if="Questions.Question.length > 0">
                <li
                  class="questionList-item"
                  v-for="q in Questions.Question"
                  :key="q.Title"
                >
                  <h3>{{ q.Title }}</h3>
                  <div class="answers">
                    <textarea cols="30" rows="10" v-model="q.Answer"></textarea>
                  </div>
                </li>
              </ol>

              <div class="sendAllAnswer">
                <div class="submitBtn">
                  <a href="javascript:void(0);" @click="send">送出</a>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div class="popUp hide" id="not_complete">
      <div class="alertWindow p_notEnough">
        <div class="p_head">
          <p>提示訊息</p>
        </div>
        <div class="p_content">
          <p>您目前還有 {{ NotCompleteCount }} 題尚未完成，是否確定要送出？</p>
        </div>
        <div class="p_foot">
          <a class="previewFirst" href="javascript:void(0)" @click="doSend"
            >是</a
          ><a
            class="previewFirst"
            href="javascript:void(0)"
            @click="hideConform"
            >否</a
          >
        </div>
      </div>
    </div>
    <div class="popUp hide" id="sent">
      <div class="alertWindow p_notEnough">
        <div class="p_head">
          <p>提示訊息</p>
        </div>
        <div class="p_content">
          <p>測驗結束</p>
        </div>
        <div class="p_foot">
          <a href="javascript:void(0);" @click="ok">確定</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageBar from "@/components/PageBar.vue";
import moment from "moment";

export default {
  components: { PageBar },
  data() {
    return {
      Breadcrumbs: [],
      Exam: null,
      Lesson: null,
      User: null,
      StartTime: null,
      LeftTime: 99999,
      Questions: null,
      NotCompleteCount: 0,
      Secret: null,
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    async load() {
      this.setBase("articlePage exam" + this.$route.params.id);
      var [result, exam, me] = await Promise.all([
        this.$api.getLesson(this.$route.params.id),
        this.$api.getExam(this.$route.params.id),
        this.$api.getMe(),
      ]);

      this.Breadcrumbs = [{ Title: exam.Title, Url: "#" }];

      this.Exam = exam;
      this.Secret = exam.Secret;
      this.Lesson = result.Lesson;
      this.User = me;
      this.StartTime = new Date().getTime();
      this.LeftTime = exam.TimeLimit;

      this.Questions = exam.Questions;

      this.counter();
    },
    counter() {
      if (this.LeftTime > 0) {
        setTimeout(() => {
          this.LeftTime--;
          if (this.LeftTime == 0) {
            this.doSend();
          } else {
            this.counter();
          }
        }, 1000);
      }
    },
    async send() {
      this.NotCompleteCount = 0;
      this.Questions.Multiple.forEach((q) => {
        if (q.Answer.length == 0) {
          this.NotCompleteCount++;
        }
      });
      this.Questions.Single.forEach((q) => {
        if (q.Answer == null) {
          this.NotCompleteCount++;
        }
      });
      this.Questions.Question.forEach((q) => {
        if (q.Answer == null) {
          this.NotCompleteCount++;
        }
      });
      if (this.NotCompleteCount > 0) {
        $("#not_complete").removeClass("hide");
        return;
      }
      this.doSend();
    },
    async doSend() {
      await this.$api.sendExam(this.$route.params.id, {
        StartTime: moment(this.StartTime).format("YYYY-MM-DD HH:mm:ss"),
        EndTime: moment().format("YYYY-MM-DD HH:mm:ss"),
        Multiple: this.Questions.Multiple,
        Single: this.Questions.Single,
        Question: this.Questions.Question,
        Secret: this.Secret,
      });
      $("#sent").removeClass("hide");
    },
    ok() {
      this.$router.replace("/lesson/" + this.$route.params.id);
    },
    hideConform() {
      $("#not_complete").addClass("hide");
    },
  },
  computed: {
    LeftMin() {
      if (this.LeftTime == 9999) {
        return 0;
      }
      return Math.floor(this.LeftTime / 60);
    },
    LeftSec() {
      if (this.LeftTime == 9999) {
        return 0;
      }
      return this.LeftTime % 60;
    },
  },
};
</script>